module.exports = __webpack_public_path__ + "assets/webgl/Assets_4_base_color.1cb2887c.jpg";